/* Thoson footer (sections/thx-footer.liquid).
   - Movil: Shop, Help y Thoson son acordeones (details). Desde 750px quedan siempre abiertos.
   - Volver arriba con scroll suave (instantaneo si se pide reducir movimiento).
   - El selector de idioma envia el formulario al cambiar.
   - Las mascotas solo se mecen mientras el footer esta a la vista. */
(function () {
  'use strict';

  var desk = window.matchMedia('(min-width: 750px)');

  function sync(ft) {
    var groups = ft.querySelectorAll('[data-thx-ft-group]');
    for (var i = 0; i < groups.length; i++) {
      if (desk.matches) {
        groups[i].open = true;
      } else if (!groups[i].hasAttribute('data-thx-ft-touched')) {
        groups[i].open = false;
      }
    }
  }

  function init(ft) {
    if (!ft || ft.hasAttribute('data-thx-ft-ready')) return;
    ft.setAttribute('data-thx-ft-ready', '');
    sync(ft);

    ft.addEventListener('click', function (e) {
      var sum = e.target.closest ? e.target.closest('.thx-ft__gsum') : null;
      if (sum && ft.contains(sum)) {
        if (desk.matches) {
          e.preventDefault();
          return;
        }
        sum.parentNode.setAttribute('data-thx-ft-touched', '');
      }

      var top = e.target.closest ? e.target.closest('[data-thx-ft-top]') : null;
      if (top && ft.contains(top)) {
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        } catch (err) {
          window.scrollTo(0, 0);
        }
        var first = document.querySelector('.thx-header a[href]') || document.querySelector('header a[href]');
        if (first && first.focus) {
          try { first.focus({ preventScroll: true }); } catch (err2) { /* foco opcional */ }
        }
      }
    });

    var sel = ft.querySelector('[data-thx-ft-lang]');
    if (sel) {
      sel.addEventListener('change', function () {
        if (sel.form) sel.form.submit();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          ft.classList.toggle('is-in-view', entries[i].isIntersecting);
        }
      }, { rootMargin: '150px 0px' });
      io.observe(ft);
    } else {
      ft.classList.add('is-in-view');
    }
  }

  function initAll(root) {
    var list = (root || document).querySelectorAll('.thx-ft');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  function onBreakpoint() {
    var list = document.querySelectorAll('.thx-ft');
    for (var i = 0; i < list.length; i++) sync(list[i]);
  }

  if (desk.addEventListener) {
    desk.addEventListener('change', onBreakpoint);
  } else if (desk.addListener) {
    desk.addListener(onBreakpoint);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
